import React, { useState, useRef, useEffect } from "react";
import * as api from "../../lib/api";
import { Input } from "../ui/input";
import { Copy, X } from "lucide-react";

export function TemplatePicker({ onPick }) {
    const [q, setQ] = useState("");
    const [items, setItems] = useState(null);
    const [open, setOpen] = useState(false);
    const [picked, setPicked] = useState(null);
    const ref = useRef(null);

    const load = () => {
        if (items === null) {
            api.getInventoryItems({ limit: 1000 }).then((r) => setItems(r.items)).catch(() => setItems([]));
        }
    };

    useEffect(() => {
        const onClickOutside = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
        document.addEventListener("mousedown", onClickOutside);
        return () => document.removeEventListener("mousedown", onClickOutside);
    }, []);

    const filtered = (items || []).filter((i) =>
        `${i.name} ${i.asset_tag} ${i.serial_number} ${i.brand} ${i.model}`.toLowerCase().includes(q.toLowerCase())
    ).slice(0, 8);

    const pick = (i) => {
        setPicked(i);
        setOpen(false);
        setQ("");
        onPick(i);
    };

    return (
        <div ref={ref} className="relative pb-3 border-b" data-testid="template-picker">
            <label className="form-label text-xs flex items-center gap-1"><Copy className="w-3 h-3 text-teal-600" />Partir d'un item existant (modèle) — optionnel</label>
            {picked ? (
                <div className="flex items-center justify-between px-3 py-2 text-sm border rounded-md bg-teal-50 border-teal-200" data-testid="template-picked">
                    <span className="text-teal-800 font-medium truncate">
                        {picked.asset_tag || picked.name}{[picked.brand, picked.model].filter(Boolean).length > 0 ? ` — ${[picked.brand, picked.model].filter(Boolean).join(" ")}` : ""}
                    </span>
                    <button type="button" onClick={() => setPicked(null)} className="text-teal-500 hover:text-teal-700 flex-shrink-0 ml-2" title="Retirer le modèle (les champs restent remplis)" data-testid="template-clear"><X className="w-4 h-4" /></button>
                </div>
            ) : (
                <Input value={q} onFocus={() => { setOpen(true); load(); }} onBlur={() => setTimeout(() => setOpen(false), 180)} onChange={(e) => { setQ(e.target.value); setOpen(true); load(); }}
                    placeholder="Rechercher un item à copier (tag, nom, modèle, SN)..." data-testid="template-search" />
            )}
            {open && !picked && (
                <div className="absolute z-50 mt-1 w-full bg-white border rounded-md shadow-lg max-h-56 overflow-y-auto" data-testid="template-dropdown">
                    {items === null && <p className="text-xs text-gray-400 p-3">Chargement...</p>}
                    {items !== null && filtered.length === 0 && <p className="text-xs text-gray-400 p-3">Aucun item trouvé</p>}
                    {filtered.map((i) => (
                        <button key={i.id} type="button" onClick={() => pick(i)} className="w-full text-left px-3 py-2 text-sm hover:bg-gray-50 border-b border-gray-50 last:border-0" data-testid={`template-option-${i.id}`}>
                            <span className="font-medium text-gray-800 font-mono">{i.asset_tag || i.name}</span>
                            <span className="text-xs text-gray-400 ml-2">{[i.brand, i.model].filter(Boolean).join(" ")}{i.serial_number ? ` • SN ${i.serial_number}` : ""}</span>
                        </button>
                    ))}
                </div>
            )}
            <p className="text-[10px] text-gray-400 mt-1">Tous les champs sont copiés sauf le N° de série et l'Asset Tag (régénéré automatiquement)</p>
        </div>
    );
}
